import { useTranslation } from "react-i18next";
import Axios from "../../../Axios.js";
import React, { useEffect, useState, forwardRef } from "react";
import Modal from "../../Modal.tsx";
import Counter from "../../Counter.tsx";
import Role from "../../../models/role.tsx";
import User from "./User.tsx";
import UserModel from "../../../models/user.tsx";
import Ability from "../../../models/ability.tsx";
import UsersRoles from "../../../models/usersRoles.tsx";
import UsersAbilities from "../../../models/usersAbilities.tsx";
import APIRequest from "../../../JS/APIRequest.ts";

import DatePicker, { registerLocale } from "react-datepicker";
import fr from "date-fns/locale/fr";
import "react-datepicker/dist/react-datepicker.css";
import MultiSelectInput from "../../MultiSelectInput.tsx";
registerLocale("fr", fr);

interface LocalRole extends Role {
    id: string
    count: number
    level: number
    users: LocalUser[]
}
interface LocalAbility extends Ability {
    id: string
    date: string
}

interface LocalUser extends User {
    name: string
    color: string
    level: number
}

class ErrorsMessages {
    email: string | undefined;
    firstname: string | undefined;
    lastname: string | undefined;
    language: string | undefined;
    groups: string | undefined;
    password: string | undefined;

    roles: string[] | undefined;
    abilities: string | undefined;

    constructor(errors?: ErrorsMessages) {
        this.email = errors?.email;
        this.firstname = errors?.firstname;
        this.lastname = errors?.lastname;
        this.language = errors?.language;
        this.groups = errors?.groups;
        this.password = errors?.password;
        this.roles = errors?.roles;
        this.abilities = errors?.abilities;
    }

    getMessage(key: string): string | undefined {
        const message = this[key];
        if (message == null) return undefined;
        return message;
    }

    printMessage(key: string) {
        const message = this[key];
        if (message == null) return undefined;
        return <p className="text-red-500 text-sm mt-1">{message}</p>
    }

    areErrors(): boolean {
        if (Object.values(this).every(key => key == null))
            return (this.roles?.length > 0)
        return true;
    }
}
interface ModalUserProps {
    isOpen: boolean
    toggle: () => any
    onClose: () => any
    currentUser: UserModel
    listRole: LocalRole[]
    listAbilities: LocalAbility[]
    listUsersRole: UsersRoles[]
    listUsersAbilities: UsersAbilities[]
}
const ModalUser = ({
    isOpen,
    toggle,
    onClose,
    currentUser,
    listRole,
    listAbilities,
    listUsersRole,
    listUsersAbilities
}: ModalUserProps) => {
    const { t } = useTranslation();

    const [email, setEmail] = useState('');
    const [firstname, setFirstName] = useState('');
    const [lastname, setLastName] = useState('');
    const [language, setLanguage] = useState('');
    const [groups, setGroups] = useState('');

    const [roles, setRoles] = useState<LocalRole[]>([]);
    const [localRoles, setLocalRoles] = useState<LocalRole[]>([])
    const [abilities, setAbilities] = useState<LocalAbility[]>([]);

    const [errors, setErrors] = useState(new ErrorsMessages());

    const [allGroups, setAllGroups] = useState([]);

    const validateForm = (): boolean => {
        const newErrors = new ErrorsMessages();

        if (email === '' || !email.includes('@')) {
            newErrors.email = t('Invalid email');
        }
        if (firstname === '') {
            newErrors.firstname = t('Invalid firstname');
        }
        if (lastname === '') {
            newErrors.lastname = t('Invalid lastname');
        }
        if (language === '') {
            newErrors.language = t('Invalid language');
        }
        if (groups === '') {
            newErrors.groups = t('Invalid group');
        }

        //date : (new Date().getTime() > Date.parse(formatDate(value))

        newErrors.roles = []
        for (let role of roles) {
            let checkRole = check(role);
            if (checkRole != null) {
                newErrors.roles.push(checkRole);
            }
        }

        setErrors(newErrors);
        return newErrors.areErrors();
    }

    const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
        toggle();

        let rolesWithLevel = roles.map(role => {
            return {
                ...role,
                level: role.level
            };
        });


        let abilitiesWithEndDate = abilities.map(ability => {
            const userAbility = listUsersAbilities.find(
                ua => ua.id_ability === ability.id && ua.id_user === currentUser.id
            );
            let endDate = ability.date && ability.date !== '' 
                ? ability.date 
                : (userAbility && userAbility.date_end ? userAbility.date_end : new Date().toISOString());

            return {
                id_ability: ability.id_ability,
                name: ability.name,
                color: ability.color,
                id: ability.id,
                end_date: endDate
            };
        });

        let json = {
            id: currentUser.id,
            email: email,
            firstname: firstname,
            lastname: lastname,
            language: language,
            group: groups,
            roles: rolesWithLevel,
            abilities: abilitiesWithEndDate,
        };


        APIRequest.updateUser(json, (res) => {
            onClose();
            handleClose();
        });
    }
}   

    const handleClose = () => {
        setEmail('');
        setFirstName('');
        setLastName('');
        setLanguage('');
        setGroups('');

        setErrors(new ErrorsMessages());
    }

    const check = (role) => {
        return null;
    }


    useEffect(() => {
        const getAllGroups = async () => {
            try {
                const response = await Axios.get('/api/groups', {
                    headers: {
                        "Content-Type": "application/json",
                        "auth-token": sessionStorage.getItem('token')
                    },
                    withCredentials: true
                });
    
                if (response.status === 200) {
                    setAllGroups(response.data);
                } else {
                    alert(t("Download failed"));
                }
            } catch (error) {
                console.error("Error during download:", error);
            }
        }
        getAllGroups();
    }, []);

useEffect(() => {
    if (listRole.length > 0 && listUsersRole.length > 0 && currentUser != null) {
        const tpm_roles: LocalRole[] = [];
        errors.roles = [];

        listUsersRole.forEach(ur => {
            if (ur.id_user === currentUser.id) {
                let role = listRole.find(r => r.id_role === ur.id_role);
                if (role != null) {
                    tpm_roles.push({
                        ...role,
                        id: role.id_role,
                        level: ur.value ?? 1
                    });

                    let checkRole = check(role);
                    if (checkRole != null) {
                        errors.roles?.push(checkRole);
                    }
                }
            }
        });

        setRoles([...tpm_roles]);
    }
}, [listUsersRole, listRole, currentUser]);

    useEffect(() => {
    for (let ability of listAbilities) {
        ability.id = ability.id_ability;
    }
    if (listAbilities.length > 0 && listUsersAbilities.length > 0 && currentUser != null) {
        const tpm_abilities: LocalAbility[] = [];
        listUsersAbilities.forEach(ua => {
            if (ua.id_user === currentUser.id) {
                let ability = listAbilities.find(a => a.id_ability === ua.id_ability);
                if (ability != null) {
                    tpm_abilities.push({
                        ...ability,
                        date: ua.date_end || ''
                    });
                }
            }
        });
        setAbilities([...tpm_abilities]);
    }
}, [listUsersAbilities, listAbilities, currentUser]);

    useEffect(() => {
        for (let role of listRole) {
            role.id = role.id_role;
        }
    }, [listRole]);

    useEffect(() => {
        if (currentUser && isOpen) {

            setEmail(currentUser.email);
            setFirstName(currentUser.firstname);
            setLastName(currentUser.lastname);
            setLanguage(currentUser.language);
            setGroups(currentUser.group);
        }
    }, [isOpen]);

    function mergeRolesWithLevel(selected: LocalRole[], previous: LocalRole[]): LocalRole[] {
    const merged = selected.map(role => {
        const prev = previous.find(r => r.id === role.id);
        return prev ? { ...role, level: prev.level } : { ...role, level: 1 };
    });
    return merged;
    }

    function mergeAbilitiesWithDate(selected: LocalAbility[], previous: LocalAbility[]): LocalAbility[] {
    return selected.map(ability => {
        const prev = previous.find(a => a.id === ability.id);
        return prev ? { ...ability, date: prev.date } : { ...ability, date: '' };
    });
}

    useEffect(() => {
    let tpmLocalRoles: LocalRole[] = [];
    for (let role of listRole) {
        if (check(role) == null)
            tpmLocalRoles.push({...role, id: role.id_role, level: 1});
    }
    setLocalRoles(tpmLocalRoles);

    errors.roles = []
    for (let role of roles) {
        let checkRole = check(role);
        if (checkRole != null)
            errors.roles.push(checkRole);
    }

}, [abilities, roles]);

    const formatDate = (string) => {
        let tab = string.split('/');
        return [tab[1], tab[0], tab[2]].join('/')
    }

    const DateInput = forwardRef(
        ({ value, onClick, className }, ref) => (
            <button
                className="border border-gray-500 rounded shadow my-px shadow h-full inline-flex bg-slate-100/30"
                onClick={onClick}
                ref={ref}
                title={t('change date')}
            >
                <p className={"text-sm text-left pl-2 pt-0.5 text-slate-700 w-28 " + ((new Date().getTime() > Date.parse(formatDate(value))) ? 'text-orange-700' : 'text-slate-700')}> {value} </p>
            </button>
        ),
    );

    const templateAbilityDate = (element: LocalAbility, handleChange: (id: string, date: string) => void) => {
    return (
        <div className='max-h-full w-[90%] text-sm rounded-md align-middle flex justify-center'>
            <div id='close-modal' className="text-left pl-2 pt-1 w-2/5">{element.name}</div>
            <div className='flex w-1/2 space-x-2'>
                <div className="relative w-full flex items-center justify-center z-50" onClick={e => e.preventDefault()}>
                    <DatePicker
                        selected={element.date ? new Date(element.date) : new Date()}
                        onChange={(date: Date | null) => {
                            setAbilities(prev =>
                                prev.map(ab =>
                                    ab.id === element.id
                                        ? { ...ab, date: date ? date.toISOString() : '' }
                                        : ab
                                )
                            );
                        }}
                        customInput={<DateInput className="example-custom-input mr-10" />}
                        toggleCalendarOnIconClick
                        dateFormat="dd/MM/yyyy"
                        isClearable={false}
                        showYearDropdown
                        locale="fr"
                        yearDropdownItemNumber={5}
                        popperClassName="!z-50"
                        popperPlacement="bottom"
                    />
                </div>
            </div>
        </div>
    );
}

const templateRole = (element: LocalRole, handleChange: (id: string, arg1: string) => void) => {

    return (
        <div className='max-h-full w-[90%] text-sm rounded-md flex items-center justify-center'>
            <div id='close-modal' className="text-left pl-2 pt-1 w-2/5">{element.name}</div>
            <div className='flex w-1/2 space-x-2'>
                <div className="w-full flex items-center justify-center" onClick={e => e.preventDefault()}>
                    <span className="ml-7">{t('level')}</span>
                    <Counter
                        value={element.level}
                        max={4}
                        min={1}
                        setValue={value => {
                            setRoles(prevRoles =>
                                prevRoles.map(role =>
                                    role.id === element.id ? { ...role, level: value } : role
                                )
                            );
                        }}
                    />
                </div>
            </div>
        </div>
    );
}


    if (!isOpen) return null;

    let form = <form className="p-5 space-x-6 flex" onSubmit={handleSubmit}>
        <div className="grid gap-3 mb-4 grid-cols-2 w-1/2 ">

            <div className=" col-span-1">
                <label htmlFor="category" className="modal-label"> {t('firstname')} </label>

                <input
                    id="firstname"
                    className="modal-input"
                    required
                    placeholder={t("firstname")}
                    onChange={(e) => {
                        setFirstName(e.target.value);
                    }}
                    value={firstname}
                />
            </div>

            <div className="col-span-1">
                <label htmlFor="category" className="modal-label">{t('lastname')}</label>
                <input id="lastname" className="bg-white border leading-none border-gray-300 text-gray-900 text-sm rounded focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" required
                    placeholder={t("lastname")}
                    onChange={(e) => {
                        setLastName(e.target.value);
                    }}
                    value={lastname}
                />
            </div>

            <div className="mb-2 col-span-2">
                <label htmlFor="category" className="modal-label">{t('email')}</label>
                <input id="email" className="bg-white border leading-none border-gray-300 text-gray-900 text-sm rounded focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" required
                    placeholder={t("email")}
                    onChange={(e) => {
                        setEmail(e.target.value);
                    }}
                    value={email}
                />
            </div>


            <div className="sm:col-span-1 col-span-1">
                <label className="modal-label">{t("language")}</label>
                <select id="language" name="language" className="bg-white border border-gray-300 text-gray-900 text-sm rounded focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5"
                    onChange={(e) => { setLanguage(e.target.value); }}
                >
                    <option defaultValue={"select"} disabled>{t('language')}</option>
                    <option value="fr">{'Francais'}</option>
                    <option value="en">{'English'}</option>
                </select>
            </div>


            <div className="sm:col-span-1 col-span-1">
                <label htmlFor="category" className="modal-label">{t("group")}</label>
                <select id="groups" name="groups" className="bg-white border leading-none border-gray-300 text-gray-900 text-sm rounded focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                    onChange={(e) => { setGroups(e.target.value); }}
                >
                    <option defaultValue={"select"} disabled>{t('group')}</option>
                    {allGroups.map((group, index) => (
                        <option key={index} value={group.id}> {group.name_groups} </option>
                    ))}
                </select>
                {errors.groups && <p className="text-red-500">{errors.groups}</p>}
            </div>
        </div>

        <div className="w-1/2">
            <div className="mb-2 col-span-2">
                <label htmlFor="category" className="modal-label">{t("abilities")}</label>

                <MultiSelectInput
                    t={t}
                    list={listAbilities}
                    selectedList={abilities}
                    setSelectedList={newSelected =>
                        setAbilities(prev => mergeAbilitiesWithDate(newSelected, prev))
                    }
                    placeHolder={t('choose abilities')}
                    template={templateAbilityDate}
                    masonry={true}
                />
            </div>

            <div className="mb-2 col-span-2">
                <label htmlFor="category" className="modal-label">{t("skills")}</label>

                <MultiSelectInput
                    t={t}
                    list={localRoles}
                    selectedList={roles}
                    setSelectedList={newSelected =>
                        setRoles(prev => mergeRolesWithLevel(newSelected, prev))
                    }
                    placeHolder={t('choose skills')}
                    check={(role) => check(role) == null}
                    update={abilities}
                    masonry={true}
                    template={templateRole}
                />
                {errors.roles?.map(roleError => <p className="text-red-500 text-sm mt-1">{roleError}</p>)}
            </div>



            <div className="flex flex-row mt-4 sm:col-span-2 col-span-2 ">
                <button className="bg-gray-300 text-gray-800 w-full px-4 py-2 rounded mx-6 hover:bg-gray-400"
                    onClick={handleClose}>
                    {t('cancel')}
                </button>
                <button className="bg-blue-500 text-white px-4 w-full py-2 rounded mx-6 hover:bg-blue-600"
                    onClick={handleSubmit}>
                    {t('add')}
                </button>
            </div>
        </div>
    </form>;

    return <Modal
        isOpen={isOpen}
        toggle={toggle}
        title={t('user')}
        form={form}
        width={70}  
    />
}

export default ModalUser;